enum VehicleType {
  AUTOMOBILE = 'automobile',
  POWERSPORTS = 'powersports',
  MARINE = 'marine',
  RV = 'recreational-vehicle'
}

export default VehicleType;
